import { Button, Tooltip } from "@material-ui/core";
import React from "react";

import { useAddOwnerFlow } from "./AddOwnerFlowContext";

export function OpenAddOwnerDialogButton() {
    const {
        setOpenAddOwnerDialog,
        boxFeatures: {
            boxOwnerSelect,
        },
    } = useAddOwnerFlow();

    return (
        <Tooltip title={boxOwnerSelect.reason}>
            <span>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenAddOwnerDialog(true)}
                    disabled={!boxOwnerSelect.enabled}
                >
                    Add Owner
                </Button>
            </span>
        </Tooltip>
    );
}
